<template>
  <div class="$attrs.class">
    <label class="upper">Triage and Crisis Protocol</label>
    <form-component>
      <form
        novalidate="novalidate"
        @submit.prevent="save"
      >
        <div class="form-row">
          <div class="col-12">
            <input-text-area
              id="crisis"
              v-model="crisis"
              name="crisis"
              label="Steps counselor should take if a student discloses that they are experiencing a crisis/emergency"
              type="text"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="col-12">
            <input-text-area
              id="nonCrisis"
              v-model="nonCrisis"
              name="nonCrisis"
              label="Steps counselor should take if student is not in crisis, but is demonstrating concerning behavior (NON-EMERGENCY)"
              type="text"
            />
          </div>
        </div>

        <button
          type="submit"
          class="btn btn-primary btn-wide mt-4"
        >
          <font-awesome-icon
            v-if="school.saving"
            :spin="true"
            :icon="['fas', 'spinner']"
            class="icon alt"
          />
          <span v-else>Save Changes</span>
        </button>
      </form>
    </form-component>
  </div>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
  name: 'Triage',

  components: {
    FormComponent,
    InputText,
    InputTextArea,
    InputSelect,
  },

  inject:['school'],

  data() {
    return {
      crisis: '',
      nonCrisis: '',
    }
  },

  mounted() {
    this.crisis = this.school.triage.crisis;
    this.nonCrisis = this.school.triage.nonCrisis;
  },

  methods: {
    async save() {
      const isValid = await this.$validator.validateAll()
      if (!isValid)
        return;

      this.errors.clear();

      try {
        await this.school.updateTriage({
          crisis: this.crisis,
          nonCrisis: this.nonCrisis,
        });
        this.$store.commit('setGlobalAlert', {
          msg: 'Triage and Crisis Protocol Saved!',
        });
      } catch {
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed to save triage and crisis protocol. Please try again!', error: true,
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
label.upper {
    @include label;

    color: $green;
    margin-bottom: 20px;
  }
</style>